module.exports = __webpack_public_path__ + "img/camping--icon--gray.baa314b1.svg";